import { BASE_URL } from '../../../../config/environmentConfig';
import { IConfirmPasswordFields } from '../../../constants/confirmAccount/confirm-account-form';
import { POST } from '../../store-helper';

export const changePassword = async (body: IConfirmPasswordFields): Promise<any> => {
  return await POST({
    pathname: `${BASE_URL.IDENTITY}/identity/ChangePassword`,
    body: { ...body, currentPassword: body.temporaryPassword },
  });
};
